/**
 * File: defaultValues.js
 * Project: Academy Johnson
 * File Created: Thursday, 6th March 2025 15:27:52 am
 * Author: Mónica Cortés Rojo (monica.cortes@aerin.es)
 * Version: 1.0.0
 * -----
 * Copyright (c) 2025 Aerin Sistemas S. L. copying, distribution or modification not authorised in writing is prohibited.
 *
 */

/*
IMPORTANTE: No editar este archivo en noname-base-frontend 
debido a que al copiar el modulo este lo reemplazara.
*/
// import {filterUrls} from "helpers/Utils";

import { menusByPermissions, isSuperUserMenus } from 'helpers/Utils';

export const UserRole = {
  Admin: 0,
  Editor: 1,
};

/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-hidden';

// Variable de la paginación de tablas

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;
export const defaultLocale = 'es';
export const localeOptions = [
  { id: 'es', name: 'Español', direction: 'ltr', country: 'ES' },
  { id: 'en', name: 'English', direction: 'ltr', country: 'US' },
  { id: 'it', name: 'Italiano', direction: 'ltr', country: 'IT' },
  { id: 'fr', name: 'Français', direction: 'ltr', country: 'FR' },
];

export const firebaseConfig = {
  apiKey: 'AIzaSyBBksq-Asxq2M4Ot-75X19IyrEYJqNBPcg',
  authDomain: 'gogo-react-login.firebaseapp.com',
  databaseURL: 'https://gogo-react-login.firebaseio.com',
  projectId: 'gogo-react-login',
  storageBucket: 'gogo-react-login.appspot.com',
  messagingSenderId: '216495999563',
};

export const currentUser = {
  id: 1,
  username: 'armando_lopez',
  name: 'Armando',
  surname: 'Lopez',
  title: 'Armando Lopez',
  email: 'armando.lopez@aerin.es',
  img: '/assets/img/profiles/l-1.jpg',
  date: 'Last seen today 15:24',
  role: UserRole.Admin,
};

export const adminRoot = '/app';
export const databaseSelected = '';
export const loginRoot = '/user/login';
export const permissionDenied = '/error';

export const searchPath = `${adminRoot}/pages/miscellaneous/search`;

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = false;
export const defaultColor = 'light.johnsonacademy';
export const isDarkSwitchActive = false;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = [
  /*
  'bluenavy',
  'blueyale',
  'blueolympic',
  'greenmoss',
  'greenlime',
  'purplemonster',
  'orangecarrot',
  'redruby',
  'yellowgranola',
  'greysteel',
  */
  'bluenoname',
  'pinknoname',
  'greennoname',
  'orangenoname',
];
export const adminMenus = [''];
export const customFilter = '';
export const actualRedirect = '/home-johnsonacademy/home-dashboard';
// TODO METER EL CUSTOMFILTER EN EL DEFAULT VALUES DE NONAME-BASE-FRONTEND

const useSuperUserMenus = process.env.REACT_APP_USE_SUPERUSER === 'true';

export const menuFunction = useSuperUserMenus
  ? isSuperUserMenus
  : menusByPermissions;
